export default [
    {
        path: '/transparency/financial',
        name: 'trust-transparency-financial',
        component: () => import('@/views/transparency/financial/Financial.vue'),
         children: [
            {
                path: '/transparency/financial/overview',
                name: 'trust-transparency-financial-overview',
                component: () => import('@/views/transparency/financial/overview/Index.vue')
            }
        ]
    },
    {
        path: '/transparency/operational',
        name: 'trust-transparency-operational',
        component: () => import('@/views/transparency/operational/Operational.vue'),
        children: [
            {
                path: '/transparency/operational/overview',
                name: 'trust-transparency-operational-overview',
                component: () => import('@/views/transparency/operational/overview/Index.vue')
            },
            {
                path: '/transparency/operational/audit',
                name: 'trust-transparency-operational-audit',
                component: () => import('@/views/transparency/operational/audit/Index.vue')
            }
        ]
    },
    {
        path: '/transparency/technical',
        name: 'trust-transparency-technical',
        component: () => import('@/views/transparency/technical/Index.vue'),
    },
]
